"use client";

import React from "react";
import { ArrowUp, ChevronRight, Clock, Mail, MapPin, Phone, Facebook, Instagram, Music, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function ContactFooterInformation() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const quickLinks = [{
    label: "Home",
    path: "/HomePage"
  }, {
    label: "Our Services",
    path: "/ServicesPage"
  }, {
    label: "Locations",
    path: "/LocationsPage"
  }, {
    label: "Contact Us",
    path: "/ContactPage"
  }];
  const serviceAreas = ["Abbotsford", "Burnaby", "Chilliwack", "Coquitlam", "Delta", "Langley", "Maple Ridge", "Mission", "New Westminster", "North Vancouver", "Pitt Meadows", "Port Coquitlam", "Port Moody", "Richmond", "Surrey", "Vancouver", "White Rock", "West Vancouver", "Whistler", "Squamish", "Pemberton"];
  return <section data-section-id="94267" id="footer" className="dark bg-background text-foreground border-t-4 border-primary pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block">
              <img src="https://proud-porpoise.10web.cloud/wp-content/uploads/2026/03/cropped-cropped-cropped-cropped-JUNK-CAR-LOGO-3.png" alt="Junk Car Pick Up BC Logo" className="h-24 w-auto" />
            </Link>
            <p className="text-muted-foreground leading-relaxed">
              Our mission is simple — to provide the fastest cash for junk cars in BC. We specialize in eco-friendly recycling and hassle-free towing, ensuring you get top dollar for your unwanted vehicle today.
            </p>
          </div>

          {}
          <div>
            <h3 className="text-lg font-serif font-bold mb-6 text-foreground tracking-tight">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.path} className="text-muted-foreground hover:text-primary transition-colors inline-flex items-center group">
                    <ChevronRight className="size-4 mr-2 text-primary/0 group-hover:text-primary transition-all -ml-6 group-hover:ml-0 opacity-0 group-hover:opacity-100" />
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-lg font-serif font-bold mb-6 text-foreground tracking-tight">
              Ready to Sell?
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Phone className="size-5 text-primary shrink-0 mt-1" />
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Call for Instant Quote</p>
                  <Link to="tel:778-385-3007" className="text-2xl sm:text-3xl font-serif font-bold text-primary hover:text-primary/80 transition-colors tracking-tighter">
                    778-385-3007
                  </Link>
                </div>
              </div>
              
              <div className="flex items-center gap-3 text-muted-foreground">
                <Mail className="size-5 text-primary shrink-0" />
                <Link to="mailto:JunkCarPickUpBC@gmail.com" className="hover:text-primary transition-colors">
                  JunkCarPickUpBC@gmail.com
                </Link>
              </div>
              
              <div className="flex items-start gap-3 text-muted-foreground">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span>Vancouver, BC, Canada</span>
              </div>
              
              <div className="flex items-center gap-3 text-muted-foreground">
                <Clock className="size-5 text-primary shrink-0" />
                <span>24/7 Rapid Response</span>
              </div>
            </div>
          </div>

          {}
          <div>
            <h3 className="text-lg font-serif font-bold mb-6 text-foreground tracking-tight">
              Service Areas
            </h3>
            <ul className="grid grid-cols-2 gap-y-3 gap-x-4">
              {serviceAreas.map((area, i) => <li key={area} data-index={i} className="flex items-center text-muted-foreground">
                  <div className="size-1.5 rounded-full bg-primary mr-2 shrink-0 shadow-[0_0_10px_rgba(132,255,28,0.5)]" />
                  <span className="text-sm">{area}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <Separator className="bg-border/30 mb-8" />

        <div className="flex justify-center space-x-4 mb-4">
          <Link to="https://www.instagram.com/junkcarpickupbc" newTab aria-label="Instagram">
            <Instagram className="size-7 text-muted-foreground hover:text-primary transition-colors" />
          </Link>
          <Link to="https://www.tiktok.com/@junkcarpickupbc" newTab aria-label="TikTok">
            <Music className="size-7 text-muted-foreground hover:text-primary transition-colors" />
          </Link>
          <Link to="https://x.com/junkcarpickupbc" newTab aria-label="X">
            <Twitter className="size-7 text-muted-foreground hover:text-primary transition-colors" />
          </Link>
          <Link to="https://www.facebook.com/junkcarpickupbc" newTab aria-label="Facebook">
            <Facebook className="size-7 text-muted-foreground hover:text-primary transition-colors" />
          </Link>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground text-center sm:text-left">
            © {new Date().getFullYear()} Junk Car Pick Up BC. All rights reserved.
          </p>
          
          <Button variant="outline" size="icon" onClick={scrollToTop} className="rounded-md border-border/50 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all shadow-md hover:shadow-[0_0_15px_rgba(132,255,28,0.4)]" aria-label="Scroll to top">
            <ArrowUp className="size-4" />
          </Button>
        </div>
      </div>
    </section>;
}